import React from "react";
import { includes } from "ramda";
import makeStyles from "@mui/styles/makeStyles";
import { useCreatorContext } from "../../CreatorContext";

import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    minWidth: 400,
  },

  thumbnail: {
    width: 45,
    height: 45,
    objectFit: "contain",
  },

  main: {
    width: 200,
    marginLeft: theme.spacing(3),
    padding: 0,
    flexGrow: 1,
  },

  title: {
    color: theme.palette.primary.brandPrimary,
    fontSize: "1.6rem",
    lineHeight: "1.7rem",
  },

  subtitle: {
    fontSize: ".9rem",
  },
}));

const CollectionCard = props => {
  const { collection } = props;
  const classes = useStyles();
  const context = useCreatorContext();

  return (
    <Container className={classes.root} maxWidth={false}>
      <Avatar
        variant="rounded"
        alt={collection.name}
        src={
          includes(collection.id, context.updatedThumbnails)
            ? `${collection.thumbnailUrl}&tc${Date.now()}`
            : collection.thumbnailUrl
        }
        className={classes.thumbnail}
      />

      <div className={classes.main}>
        <Typography noWrap classes={{ root: classes.title }}>
          {collection.name}
        </Typography>
      </div>
    </Container>
  );
};

export default CollectionCard;
